import React from 'react';
import { Button } from '@mui/material';
import ENV from '../../../../../../commons/environment';

interface UserAppQuickAccessComponentProps {
  apiKey: string;
}

export default function UserAppQuickAccessComponent(props: UserAppQuickAccessComponentProps) {
  const [apiKey, setApiKey] = React.useState<string>('');

  const [beautyAdminUrl, setBeautyAdminUrl] = React.useState<string>('');
  const [beautyCheckinUrl, setBeautyCheckinUrl] = React.useState<string>('');
  const [beautyCheckoutUrl, setBeautyCheckoutUrl] = React.useState<string>('');

  const updateAppUrls = (apiKey: string) => {
    setBeautyAdminUrl(`${ENV.BEAUTY_ADMIN_URL}/auth/login?tkn=${encodeURIComponent(apiKey)}`);
    setBeautyCheckinUrl(`${ENV.BEAUTY_CHECKIN_URL}/auth?tkn=${encodeURIComponent(apiKey)}`);
    setBeautyCheckoutUrl(`${ENV.BEAUTY_CHECKOUT_URL}/auth?tkn=${encodeURIComponent(apiKey)}`);
  };

  React.useEffect(() => {
    setApiKey(props?.apiKey);
  }, [props]);

  React.useEffect(() => {
    updateAppUrls(apiKey);
  }, [apiKey]);

  return (
    <>
      {apiKey ? (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <Button
            variant="contained"
            color="primary"
            style={{ marginTop: '30px' }}
            target="_blank"
            href={beautyAdminUrl}
          >
            Open Beauty Admin
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ marginTop: '30px' }}
            target="_blank"
            href={beautyCheckoutUrl}
          >
            Open Beauty Checkout
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ marginTop: '30px' }}
            target="_blank"
            href={beautyCheckinUrl}
          >
            Open Beauty Checkin
          </Button>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
